import {
  DAYS_PER_WEEK,
  getCalendarCellDate,
  getCalendarCellId,
} from "./calendarWeeks";

export interface CalendarPhaseYear {
  start: number;
  end: number;
  startDate: string;
  lastDate: string;
}

export function getCalendarPhaseYear(year: number): CalendarPhaseYear {
  return {
    start: getCalendarCellId(`${year}-01-01`),
    end: getCalendarCellId(`${year + 1}-01-01`),
    startDate: `${year}-01-01`,
    lastDate: `${year}-12-31`,
  };
}

export function getCalendarCellYear(cellId: number): number {
  return Number(getCalendarCellDate(cellId).slice(0, 4));
}

export function getCalendarPhaseYearWeeks(phaseYear: CalendarPhaseYear) {
  const weeks: { start: number; end: number }[] = [];
  let start = phaseYear.start;

  while (start < phaseYear.end) {
    const end = Math.min(
      (Math.floor(start / DAYS_PER_WEEK) + 1) * DAYS_PER_WEEK,
      phaseYear.end,
    );
    weeks.push({ start, end });
    start = end;
  }

  return weeks;
}
